export class DateUtils {
	public static GetTimestamp(): string {
		const date = new Date();
		const yyyy: number = date.getFullYear();
		const mm: string = ("0" + (date.getMonth() + 1)).slice(-2);
		const dd: string = ("0" + date.getDate()).slice(-2);
		const sec: number = date.getSeconds();
		const ms: number = date.getMilliseconds();
		const dateString: string = `${yyyy}${mm}${dd}${sec}${ms}`;
		return dateString;
	}

	public static GetStringWithSlash(date: Date | undefined): string {
		if (date === undefined) {
			return "";
		}
		const dateString: string = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
		return dateString;
	}

	public static GetStringWithHyphen(date: Date | undefined): string {
		if (date === undefined) {
			return "";
		}
		const yyyy: number = date.getFullYear();
		const mm: string = ("0" + (date.getMonth() + 1)).slice(-2);
		const dd: string = ("0" + date.getDate()).slice(-2);
		const dateString: string = `${yyyy}-${mm}-${dd}`;
		return dateString;
	}

	public static IsSame(date1: Date, date2: Date): boolean {
		const year1: number = date1.getFullYear();
		const year2: number = date2.getFullYear();
		if (year1 !== year2) {
			return false;
		}
		const month1: number = (date1.getMonth() + 1);
		const month2: number = (date2.getMonth() + 1);
		if (month1 !== month2) {
			return false;
		}
		const day1: number = date1.getDate();
		const day2: number = date2.getDate();
		if (day1 !== day2) {
			return false;
		}
		return true;
	}
}
